// Web-only strings for plugin UI (shared/API.md §36): interactive dialogs. The sentences are the
// contract's own (§36.4), used verbatim by every client; BOTH languages. Keys prefixed `web.dialog.`.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.dialog.optional': ' (opcional)',
    'web.dialog.submit': 'Enviar',
    'web.dialog.cancel': 'Cancelar',
    'web.dialog.failed': 'No se pudo enviar. Inténtalo de nuevo.',
    'web.dialog.error.required': 'Este campo es obligatorio.',
    'web.dialog.error.tooShort': 'La longitud mínima es %@.',
    'web.dialog.error.tooLong': 'La longitud máxima es %@.',
    'web.dialog.error.badEmail': 'Debe ser un correo electrónico válido.',
    'web.dialog.error.notNumber': 'Debe ser un número.',
    'web.dialog.error.badUrl': 'La URL debe incluir http:// o https://.',
    'web.dialog.error.invalidOption': 'Debe ser una opción válida.',
    'web.dialog.select.none': 'Selecciona una opción',
    'web.dialog.users.search': 'Busca a una persona',
    'web.dialog.users.clear': 'Quitar',
    'web.dialog.channels.none': 'Selecciona un canal',
  },
  en: {
    'web.dialog.optional': ' (optional)',
    'web.dialog.submit': 'Submit',
    'web.dialog.cancel': 'Cancel',
    'web.dialog.failed': "Couldn't submit. Try again.",
    'web.dialog.error.required': 'This field is required.',
    'web.dialog.error.tooShort': 'Minimum input length is %@.',
    'web.dialog.error.tooLong': 'Maximum input length is %@.',
    'web.dialog.error.badEmail': 'Must be a valid email address.',
    'web.dialog.error.notNumber': 'Must be a number.',
    'web.dialog.error.badUrl': 'URL must include http:// or https://.',
    'web.dialog.error.invalidOption': 'Must be a valid option.',
    'web.dialog.select.none': 'Select an option',
    'web.dialog.users.search': 'Search for a person',
    'web.dialog.users.clear': 'Remove',
    'web.dialog.channels.none': 'Select a channel',
  },
};
